<script setup>
  import { computed } from "vue";
  import { useMapStore } from "@/stores/MapStore";
  import SegmentedControl from "@/components/controls/SegmentedControl.vue";
  import SegmentedControlButton from "@/components/controls/SegmentedControlButton.vue";
  import Toggle from "@/components/controls/Toggle.vue";

  const mapStore = useMapStore();

  const satelliteProduct = computed({
    get: () => mapStore.state.settings.satellite?.product || "vis",
    set: (product) => {
      // Visible has no enhanced color, so selecting it also turns the palette back to 0
      mapStore.setSatelliteSettings(product === "vis" ? { product, palette: 0 } : { product });
    },
  });

  const enhancedColorDisabled = computed(() => satelliteProduct.value === "vis");

  // Palette 0 is the default. Palette 1 is enhanced color.
  const enhancedColor = computed({
    get: () => !enhancedColorDisabled.value && mapStore.state.settings.satellite?.palette === 1,
    set: (enabled) => mapStore.setSatelliteSettings({ palette: enabled ? 1 : 0 }),
  });
</script>

<template>
  <div class="jwx-map__source-selector jwx-wrapper-block jwx-wrapper-block--column jwx-wrapper-block--transparent-border">
    <div class="jwx-wrapper-block__content">
      <SegmentedControl
        v-model="satelliteProduct"
        label="Select the satellite product to show."
        class="w-100"
      >
        <SegmentedControlButton value="vis">Visible</SegmentedControlButton>
        <SegmentedControlButton value="wv">Water Vapor</SegmentedControlButton>
        <SegmentedControlButton value="ir">Infrared</SegmentedControlButton>
      </SegmentedControl>

      <Toggle
        v-model="enhancedColor"
        :disabled="enhancedColorDisabled"
        size="small"
        id="satellite-enhanced-color"
        name="satellite-enhanced-color"
        class="satellite-enhanced-color w-100"
      >
        Enhanced Color
      </Toggle>
    </div>
  </div>
</template>

<style scoped>
  .jwx-wrapper-block__content {
    padding: var(--jwx-block-spacing);
  }

  .satellite-enhanced-color {
    margin-top: 6px;
  }

  .satellite-enhanced-color :deep(.jwx-toggle__label) {
    flex: 1;
  }
</style>
